/* Kalve global: scroll lock helper, focus helpers, hamburger menu overlay, header hide on scroll down.
   Delegated listeners only, so it survives theme-editor section re-renders. */
(function () {
  'use strict';
  if (window.KalveGlobal) return;

  var root = document.documentElement;
  var locks = {};

  function lockCount() { return Object.keys(locks).length; }

  function lockScroll(id) {
    if (!lockCount()) {
      var sbw = window.innerWidth - root.clientWidth;
      if (sbw > 0) root.style.setProperty('--k-sbw', sbw + 'px');
      root.classList.add('k-locked');
      /* a hidden (scrolled-away) header would otherwise slide back out while an overlay opens */
      var wrap = document.querySelector('.k-section-header');
      if (wrap) wrap.classList.remove('k-hide');
    }
    locks[id] = true;
  }

  function unlockScroll(id) {
    delete locks[id];
    if (!lockCount()) {
      root.classList.remove('k-locked');
      root.style.removeProperty('--k-sbw');
    }
  }

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function focusables(container) {
    return Array.prototype.filter.call(container.querySelectorAll(FOCUSABLE), function (el) {
      return !el.hidden && !el.closest('[hidden]') && !el.closest('[inert]') && (el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    });
  }

  /* Keep Tab / Shift+Tab inside container. Call from a keydown handler. */
  function trapTab(container, event) {
    if (event.key !== 'Tab') return;
    var items = focusables(container);
    if (!items.length) { event.preventDefault(); return; }
    var first = items[0], last = items[items.length - 1], active = document.activeElement;
    if (!container.contains(active)) { event.preventDefault(); first.focus(); return; }
    if (event.shiftKey && active === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && active === last) { event.preventDefault(); first.focus(); }
  }

  window.KalveGlobal = { lockScroll: lockScroll, unlockScroll: unlockScroll, focusables: focusables, trapTab: trapTab };

  /* ---------- hamburger menu overlay ---------- */
  var openMenu = null; // { menu, opener }

  var CLOSE_MS = 260; // keep in step with the .k-menu opacity transition in kalve-base.css

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* the overlay fades in/out: it stays in the DOM (and the scroll lock stays on) until the fade-out ends */
  function finishClose(menu) {
    clearTimeout(menu._kTimer);
    menu._kTimer = 0;
    menu.classList.remove('k-open');
    menu.hidden = true;
    if (!openMenu) {
      root.classList.remove('k-menu-open');
      unlockScroll('menu');
    }
  }

  function showMenu(opener) {
    var id = opener.getAttribute('aria-controls');
    var menu = id && document.getElementById(id);
    if (!menu) return;
    clearTimeout(menu._kTimer);
    menu._kTimer = 0;
    menu.hidden = false;
    opener.setAttribute('aria-expanded', 'true');
    lockScroll('menu');
    root.classList.add('k-menu-open'); // lifts the header's stacking context above page content (see kalve-base.css)
    openMenu = { menu: menu, opener: opener };
    void menu.offsetWidth; // commit the hidden state so the fade-in transitions
    menu.classList.add('k-open');
    var nav = menu.querySelector('nav');
    if (nav) nav.scrollTop = 0;
    var x = menu.querySelector('[data-k-menu-close]');
    if (x) x.focus({ preventScroll: true });
  }

  function hideMenu(restoreFocus, instant) {
    if (!openMenu) return;
    var m = openMenu;
    openMenu = null;
    m.opener.setAttribute('aria-expanded', 'false');
    m.menu.classList.remove('k-open');
    if (instant || reducedMotion()) finishClose(m.menu);
    else m.menu._kTimer = setTimeout(function () { finishClose(m.menu); }, CLOSE_MS);
    if (restoreFocus !== false && m.opener.isConnected) m.opener.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var opener = t.closest('[data-k-menu-open]');
    if (opener) { e.preventDefault(); showMenu(opener); return; }
    if (t.closest('[data-k-menu-close]')) { e.preventDefault(); hideMenu(); return; }
    var link = t.closest('[data-k-menu] a[href]');
    if (link && openMenu) {
      var href = link.getAttribute('href') || '';
      /* same-page anchors do not reload, so close the overlay by hand */
      if (href.charAt(0) === '#') hideMenu(false);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!openMenu) return;
    if (e.key === 'Escape') { e.preventDefault(); hideMenu(); return; }
    trapTab(openMenu.menu, e);
  });

  /* leaving through a menu link must not restore a locked page when the browser comes back from its back/forward cache */
  window.addEventListener('pagehide', function () { hideMenu(false, true); });

  /* theme editor: a re-rendered header drops the open menu */
  document.addEventListener('shopify:section:unload', function () {
    if (openMenu && !openMenu.menu.isConnected) { openMenu = null; root.classList.remove('k-menu-open'); unlockScroll('menu'); }
  });

  /* ---------- header hides on scroll down, returns on scroll up ---------- */
  var headerEl = null;
  var lastY = window.pageYOffset || 0;
  var acc = 0; // scrolled distance in the current direction; the bar only flips after a deliberate swipe, so small jitters and iOS rubber-banding do not make it flicker
  var ticking = false;

  function headerWrap() {
    if (!headerEl || !headerEl.isConnected) {
      var h = document.querySelector('[data-k-header]');
      headerEl = h ? (h.closest('.shopify-section') || h.parentElement) : null;
    }
    return headerEl;
  }

  function onScroll() {
    ticking = false;
    var wrap = headerWrap();
    var raw = window.pageYOffset || 0;
    if (wrap) wrap.classList.toggle('k-scrolled', raw > 8); // see-through header turns solid once the page moves
    var maxY = Math.max(0, root.scrollHeight - window.innerHeight);
    if (raw < 0 || raw > maxY + 1) return; // overscroll bounce at the top / bottom edge: ignore
    var y = raw;
    var dy = y - lastY;
    if ((dy > 0 && acc < 0) || (dy < 0 && acc > 0)) acc = 0;
    acc += dy;
    if (wrap && !root.classList.contains('k-locked')) {
      if (y < 120 || acc < -6) wrap.classList.remove('k-hide');
      else if (acc > 10) wrap.classList.add('k-hide');
    }
    lastY = y;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); }
  }, { passive: true });

  /* announcement strip height -> --k-ann (sticky offset), so only the header bar stays pinned */
  var annTimer = null;
  function measureAnnouncement() {
    var wrap = headerWrap();
    if (!wrap) return;
    var a = wrap.querySelector('.k-announce');
    wrap.style.setProperty('--k-ann', (a ? Math.round(a.getBoundingClientRect().height) : 0) + 'px');
  }
  window.addEventListener('resize', function () { clearTimeout(annTimer); annTimer = setTimeout(measureAnnouncement, 100); });
  if (window.ResizeObserver) {
    /* the strip can re-wrap when web fonts swap in or the text is edited: keep the sticky offset exact */
    var annObs = new ResizeObserver(function () { measureAnnouncement(); });
    var watchAnn = function () { var w = headerWrap(); var a = w && w.querySelector('.k-announce'); annObs.disconnect(); if (a) annObs.observe(a); };
    document.addEventListener('shopify:section:load', watchAnn);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchAnn); else watchAnn();
  }
  document.addEventListener('shopify:section:load', function () { headerEl = null; measureAnnouncement(); syncScrolled(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', measureAnnouncement); else measureAnnouncement();

  /* page opened (or restored) part-way down: start with the solid bar */
  function syncScrolled() {
    var wrap = headerWrap();
    if (wrap) wrap.classList.toggle('k-scrolled', (window.pageYOffset || 0) > 8);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncScrolled); else syncScrolled();
  window.addEventListener('pageshow', syncScrolled);

  /* ---------- footer columns: accordions on phones, open static columns on desktop ---------- */
  var footMq = window.matchMedia ? window.matchMedia('(max-width: 900px)') : null;

  function syncFooter() {
    var mobile = !!(footMq && footMq.matches);
    Array.prototype.forEach.call(document.querySelectorAll('[data-k-fcol]'), function (col) {
      col.open = !mobile;
      var sum = col.querySelector('summary');
      if (!sum) return;
      if (mobile) { sum.removeAttribute('tabindex'); sum.removeAttribute('role'); }
      else { sum.setAttribute('tabindex', '-1'); sum.setAttribute('role', 'presentation'); }
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var sum = t.closest('[data-k-fcol] > summary');
    if (sum && footMq && !footMq.matches) e.preventDefault(); // desktop: the columns are always open
  });
  if (footMq) { if (footMq.addEventListener) footMq.addEventListener('change', syncFooter); else if (footMq.addListener) footMq.addListener(syncFooter); }
  document.addEventListener('shopify:section:load', syncFooter);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncFooter); else syncFooter();

  /* keyboard users tabbing into the hidden header bring it back */
  document.addEventListener('focusin', function (e) {
    var wrap = headerWrap();
    if (wrap && wrap.classList.contains('k-hide') && wrap.contains(e.target)) wrap.classList.remove('k-hide');
  });
  /* ---------- safety net: finish tags such as "[gold]" at the end of an image alt are editor-only; never expose them ---------- */
  var ALT_TAG = /\s*\[[^\]]*\]\s*$/;
  function cleanAlt(img) {
    if (!img || img.tagName !== 'IMG' || img.closest('.k-pdp__gal')) return;
    var a = img.getAttribute('alt');
    if (a && ALT_TAG.test(a)) img.setAttribute('alt', a.replace(ALT_TAG, ''));
  }
  function cleanAltsIn(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.tagName === 'IMG') cleanAlt(node);
    else if (node.querySelectorAll) Array.prototype.forEach.call(node.querySelectorAll('img[alt*="["]'), cleanAlt);
  }
  function startAltNet() {
    cleanAltsIn(document.body);
    if (!window.MutationObserver) return;
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        if (m.type === 'attributes') cleanAlt(m.target);
        else Array.prototype.forEach.call(m.addedNodes, cleanAltsIn);
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['alt'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startAltNet); else startAltNet();
})();
